/**
 * texte-i18n.ts — choisir la variante FR / EN d'un texte stocké en deux colonnes (titre, but,
 * raison, libellé d'une situation…), selon la langue de l'interface.
 *
 * Un seul helper partagé (lot 8 du plan PR #7) : le ternaire `lang === "en" ? x.fooEn : x.fooFr`
 * s'était recopié dans une dizaine de fichiers, chacun avec son propre repli (ou sans repli : un
 * texte EN absent donnait une ligne vide en mode anglais). Le garde-fou
 * `tests/i18n-no-raw-label.test.ts` refuse désormais ce ternaire sur un libellé.
 *
 * ⚠️ Pour un CRITÈRE (libellé, comportement, aide, verdict), ne pas utiliser ce helper : passer
 * par `pickScoringLabel` / `pickBehaviorText` / `pickCriterionHelp` / `pickVerdictLabel`
 * (`scoring-i18n.ts`), qui connaissent aussi la langue d'entraînement du lecteur.
 */

const estAnglais = (lang: string | null | undefined) => (lang || "fr").toLowerCase().startsWith("en");

/** EN → en || fr ; FR → fr || en ; `""` si les deux manquent. */
export function pickFrEn(fr: string | null | undefined, en: string | null | undefined, lang: string | null | undefined): string {
  const picked = estAnglais(lang) ? (en || fr) : (fr || en);
  return picked ?? "";
}

/** Même règle pour une valeur quelconque (objet de traductions, liste…) : EN → en ?? fr ; FR → fr ?? en. */
export function pickFrEnValue<T>(fr: T | null | undefined, en: T | null | undefined, lang: string | null | undefined): T | undefined {
  return (estAnglais(lang) ? (en ?? fr) : (fr ?? en)) ?? undefined;
}
